import { blue, green } from '@ant-design/colors'
import React, { FC, useCallback } from 'react'
import { createUseStyles } from 'react-jss'
import { Colors } from '../../../common/constants/colors'
import { addTutorToSubject, removeTutorFromSubject } from '../../../common/logic/subject-logic'
import { Subject, Tutor } from '../../../common/types/types'
import { RecordWithID } from '../../../common/types/utils'

type TutorAddedtoSubjectToggleProps = {
	subject: RecordWithID<Subject>
	tutor: RecordWithID<Tutor>
	isAdded: boolean
}

export const TutorAddedtoSubjectToggle: FC<TutorAddedtoSubjectToggleProps> = ({
	subject,
	tutor,
	isAdded,
}) => {

	// hooks
	const styles = useStyles()

	// event handlers
	const handleClick = useCallback(() => {
		if (!isAdded) {
			addTutorToSubject(tutor.id, subject.id)
		} else {
			removeTutorFromSubject(tutor.id, subject.id)
		}
	}, [tutor.id, subject.id, isAdded])

	return (
		<div className={`${styles.tutorAddedToSubjectToggle} ${isAdded && styles.added}`} onClick={handleClick}>
			{isAdded ? 'Added' : 'Add'}
		</div>
	)
}

const useStyles = createUseStyles({
	tutorAddedToSubjectToggle: {
		display: 'grid',
		border: `1px solid ${blue.primary}`,
		color: blue.primary,
		fontWeight: 500,
		gridTemplateColumns: '80px',
		justifyContent: 'center',
		textAlign: 'center',
		padding: 8,
		borderRadius: 6,
		userSelect: 'none',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: blue[0],
		},
		'&:active': {
			backgroundColor: blue[1],
		},
	},
	added: {
		borderColor: green.primary,
		color: green.primary,
		'&:hover': {
			backgroundColor: green[0],
		},
		'&:active': {
			backgroundColor: green[1],
		},
	},
})